import React from 'react';
import { Card } from 'semantic-ui-react';
import ApiRequestsTable from '../../components/ApiRequestsTable';

const ApiRequest = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>API 请求记录</Card.Header>
          <ApiRequestsTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default ApiRequest;
